import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { hideLoader, showLoader } from "../../../../store/actions";
import {
  getDetailsFromPincode,
  getFatcaDetails,
  saveFatcaDetails,
} from "../../../../store/actions/newSubscriber";
import { useNewSubscriberContext } from "../Context/NewSubsciberContext";
import {
  setFatcaDetails,
  setStatusBackToSummary,
} from "../Context/NewSubscriberAction";
import CardComponent from "../../transactions/newInvestor/lib/CardComponent";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormTextInput from "./lib/formik/InputField";
import { useRef } from "react";
import FormSelectInput from "./lib/formik/inputSelectField";
import { SUCCESS_RESPONSE_CODE } from ".";

const Fatca = () => {
  const history = useHistory();
  const {
    ackNumber,
    kycDetails = {},
    dispatch: dispatchContext,
    EKYCDetails = {},
    kycBankDetails = {},
    isBackToSummary = false,
    fatcaDetails = { data: {} },
    District,
    statesList,
    countriesList,
  } = useNewSubscriberContext();

  const {
    data: { ListFatcaDetails = [] },
  } = fatcaDetails || { data: { ListFatcaDetails: [] } } || {};
  const [_existingFatcaDetails] = ListFatcaDetails;
  const { data = {} } = kycDetails || {};
  const EKYCdata = EKYCDetails?.data?.result?.PERSONAL_DETAILS || {};

  const dispatch = useDispatch();

  const [address, setAddress] = useState({});
  const [isAddressLoading, setIsAddressLoading] = useState(true);

  const goBack = () => history.push("/nps/AddSubs/personal-details");

  const [residentState, setResidentState] = useState("Y");

  useEffect(() => {
    (async function () {
      try {
        const pincode = [
          EKYCdata?.PERM_PIN,
          kycBankDetails?.PinCode,
          data?.pin_code1,
          _existingFatcaDetails?.PinCode,
        ].find(Boolean);

        if (!pincode) return;

        const response = await dispatch(getDetailsFromPincode({ pincode }));

        if (Number(response.statusCode) === SUCCESS_RESPONSE_CODE) {
          const { data: stateAndDistrictDetails } = response;
          const { Country, District, State } = stateAndDistrictDetails[0];
          setAddress({
            country: Country,
            district: District,
            state: State,
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsAddressLoading(false);
      }
    })();
  }, []);

  const initialValues = _existingFatcaDetails
    ? {
        resident: _existingFatcaDetails.Country === "IN" ? "Y" : "N",
        usResident: _existingFatcaDetails.UsPerson === "N" ? "N" : "Y",
        line1: _existingFatcaDetails.Address,
        line2: "",
        pincode: _existingFatcaDetails.PinCode || "",
        state: _existingFatcaDetails.State || "",
        district: _existingFatcaDetails.City || District || "",
        country: _existingFatcaDetails.Country,
      }
    : {
        resident: "Y",
        usResident: "N",
        line1:
          EKYCdata?.PERM_LINE1 ||
          kycBankDetails?.Address1 ||
          data.txtAddress1 ||
          "",
        line2:
          EKYCdata?.PERM_LINE2 ||
          kycBankDetails?.Address2 ||
          data.txtAddress2 ||
          "",
        pincode:
          EKYCdata?.PERM_PIN || kycBankDetails?.PinCode || data.pin_code1 || "",
        district:
          address?.district ||
          EKYCdata?.PERM_DIST ||
          kycBankDetails?.District ||
          data.txtCity1 ||
          "",
        state: address?.state || kycBankDetails?.StateName || data.State1 || "",
        country: "IN",
      };

  const validationSchema = Yup.object().shape({
    resident: Yup.string().required("I am tax resident of India is required"),
    usResident: Yup.string().required("I am a US resident is required"),
    line1: Yup.string()
      .required("Address line 1 is required")
      .matches(/^(?!\s+$).+$/, "Address cannot be empty"),
    pincode: Yup.string()
      .required("Pincode is required")
      .matches(/^[0-9]{6}$/, "Invalid Pincode"),
    district: Yup.string().required("District is required"),
    state: Yup.string().required("State is required"),
    country: Yup.string().required("Country is required"),
  });

  const ref = useRef();

  const _handleSubmit = async (values) => {
    try {
      dispatch(showLoader());
      const params = {
        AckNumber: ackNumber,
        UsSelection: values.usResident,
        ResidenceforTaxPursposes: values.resident,
        BirthCountry: values.country,
        txtAddress1: values.line1,
        txtAddress2: values.line2,
        txtcity1: values.district,
        pin_code1: values.pincode,
        TinNumber1: values.tinNumber,
        State1: values.state,
      };
      const response = await dispatch(saveFatcaDetails(params));

      if (+response.statusCode === SUCCESS_RESPONSE_CODE) {
        const updatedFatcaDetails = await dispatch(
          getFatcaDetails({
            AckNumber: ackNumber,
          })
        );
        dispatchContext(setFatcaDetails(updatedFatcaDetails));
        isBackToSummary && dispatchContext(setStatusBackToSummary(false));
        isBackToSummary
          ? history.push({
              pathname: "/nps/AddSubs/subscriber-summary",
            })
          : history.push({
              pathname: "/nps/AddSubs/investment-details",
            });
      } else {
        alert(response.message);
      }
    } catch (error) {
      alert(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  return (
    <>
      {!isAddressLoading ? (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          innerRef={ref}
          onSubmit={_handleSubmit}
        >
          {({ values, setFieldValue, errors, setFieldTouched, setValues }) => (
            <Form>
              <CardComponent title="FATCA/CRS DECLARATION">
                <div className="new-investor-container">
                  {/* <FormRadioGroup
                  label="I am tax resident of India"
                  name="resident"
                  options={residentOption}
                  onChange={(e) => {
                    setFieldValue("resident", e.target.value);
                    setResidentState(e.target.value);
                    setFieldValue("country", "IN");
                  }}
                  required
                /> */}
                  {/* {values.resident === "N" && (
                  <FormRadioGroup
                    label="I am a US resident"
                    name="usResident"
                    options={usResidentOption}
                    required
                  />
                )} */}
                  <span className="address-note">
                    Address in the Jurisdiction of Tax Residence
                  </span>
                  <FormTextInput
                    label="Address line 1"
                    name="line1"
                    required
                    disabled={EKYCdata?.PERM_LINE1}
                  />
                  {/* <FormTextInput
                  label="Address line 2"
                  name="line2"
                  disabled={EKYCdata?.PERM_LINE2}
                /> */}

                  <FormTextInput
                    label="Pincode"
                    name="pincode"
                    required
                    disabled={EKYCdata?.PERM_PIN}
                    onBlur={() => {
                      setFieldTouched("pincode", true);
                      setTimeout(async () => {
                        if (!errors["pincode"]) {
                          const response = await dispatch(
                            getDetailsFromPincode({ pincode: values.pincode })
                          );
                          if (+response.statusCode === SUCCESS_RESPONSE_CODE) {
                            const { data } = response;
                            const { Country, District, State } = data[0];
                            setValues({
                              ...values,
                              state: State,
                              district: District,
                              country: Country,
                            });
                          }
                        }
                      }, 0);
                    }}
                  />
                  <FormTextInput
                    label="City / District"
                    name="district"
                    required
                    disabled={
                      Boolean(EKYCdata?.PERM_DIST) ||
                      Boolean(values.pincode && values?.district)
                    }
                  />
                  <FormSelectInput
                    label="State/U.T"
                    name="state"
                    options={statesList}
                    required
                    disabled={Boolean(values.pincode && values?.state)}
                  />
                  <FormSelectInput
                    label="Country"
                    name="country"
                    options={countriesList}
                    disabled={residentState === "Y"}
                    required
                  />
                </div>
              </CardComponent>
              <>
                <div className="d-flex justify-content-center">
                  <button
                    className="new-investor-button"
                    onClick={goBack}
                    disabled={!goBack}
                    style={{ border: "1px solid #007ac8", color: "#007ac8" }}
                  >
                    Back
                  </button>
                  <button
                    type="submit"
                    className="new-investor-button new-investor-active"
                  >
                    Proceed
                  </button>
                </div>
              </>
            </Form>
          )}
        </Formik>
      ) : null}
    </>
  );
};

export default Fatca;
